import React from "react";

const ChangeCard = ({ from, to }) => {
    return (
        <>
            <div className="card-flex flex tags-wrapper py-2 px-2">
                <div className="tags-items">{from}</div>
                <div className="mx-2">
                    <span className="fas fa-arrow-right text-xs text-primary-color-orange"></span>
                </div>
                <div className="tags-items">{to}</div>
            </div>
        </>
    );
};

export default ChangeCard;
